let APIURL="/API/panthrixAPI"
//let APIURL="https://panthrix.club/API/panthrixAPI"
//let APIURL= "http://localhost:55106/API/panthrixAPI"


export default{
	APIURL:APIURL,
}